import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'products',
    labelKey: 'chatbot.suggestions.products',
    messageKey: 'chatbot.suggestions.products',
  },
  {
    id: 'history',
    labelKey: 'chatbot.suggestions.history',
    messageKey: 'chatbot.suggestions.history',
  },
  {
    id: 'yeast',
    labelKey: 'chatbot.suggestions.yeast',
    messageKey: 'chatbot.suggestions.yeast',
  },
]

export const contactCTAs: ContactCTA[] = [
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 011 9800718',
  },
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@bonifanti.com',
  },
]
